
const initialState = {
    stateProvisorio:false
};

export const stateProvisorioReducer = (state = initialState, action) => {   
    switch (action.type) {
        case 'cambiarStadoProvisorio':
          return {
            stateProvisorio:action.payload
          };
        default:
          return state;
      }
};